import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { useChatbot } from './chatBotContext';


const ChatBotButton = () => {
  const { isVisible, showChatbot } = useChatbot();

  if (isVisible) return null;
  return (
    <Tooltip title="Help" placement="left">
      <Fab
        color="secondary"
        
        onClick={() => {
          showChatbot();
        }}
        style={{
          position: 'fixed',
          bottom: '5rem',
          right: '3rem',
          backgroundColor: '#460073', // Purple
          color: 'white',
          zIndex: 9999,
          width:'40px',
          height:'40px',
          borderRadius: '50%',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
          }}
      >
        <MenuBookIcon />
      </Fab>
    </Tooltip>
  );
};

export default ChatBotButton;
